import React from 'react';
import About from './About/About.component';
import { MainContentContainer, MainSection } from '../OtherPages.styles';
import SideContainerComponent from '../SideContainer.component';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';

const AboutUsPage = () => {
  return (
    <MainContentContainer>
      <HelmetHelper
        title="About Yoda Safety Services"
        description="Learn about Yoda Safety Services and our approach to workplace safety training, safety programs, audits, manuals, and support for businesses across Atlantic Canada and beyond."
      />
      <SideContainerComponent />
      <MainSection>
        <About />
      </MainSection>
    </MainContentContainer>
  );
};

export default AboutUsPage;
